import { html } from 'lit';
import componentStyles from './location-card-grid.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export default class LocationCardGrid extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * location page details link
       */
      detailsLink: { type: String },
      /**
       * location title
       */
      title: { type: String },
      /**
       * Card Header Level
       */
      levelHeader: { type: String },
    };
  }

  constructor() {
    super();
    this.detailsLink = '';
    this.title = '';
    this.levelHeader = '2'
  }

  render() {
    return html`
      <div class="location-card-grid">
        <div class="location-card-grid__body">
          <hf-link href="${this.detailsLink}">
            <hf-heading
              level="${this.levelHeader}"
              levelstyle="heading5"
              class="location-card-grid__title"
            >
              ${this.title}
            </hf-heading>
          </hf-link>

          <div class="location-card-grid__content">
            <div class="location-card-grid__address">
              <hf-icon
                name="location"
                class="location-card-grid__icon"
              ></hf-icon>
              <div class="location-card-grid__address-content">
                <slot name="addressLine1"></slot>
                <slot name="addressLine2"></slot>
              </div>
            </div>

            <div class="location-card-grid__phone">
              <hf-icon name="phone" class="location-card-grid__icon"></hf-icon>
              <slot name="phone"></slot>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-location-card-grid', LocationCardGrid);
